import React from 'react';
import SearchParams from '../Elements/SearchParams';
import FreelancerLineItemSearchParams from '../Contents/FreelancerInvoicing/FreelancerLineItem/FreelancerLineItemSearchParams';
import FreelancerLineItem from '../Domain/FreelancerLineItem';
import AuthService from './authService.js';

class FreelancerLineItemService extends React.Component {
  static GetFreelancerLineItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, FreelancerLineItemSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/FreelancerLineItem/GetFreelancerLineItems?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  // static GetFreelancerLineItembyId(id) {
  //   const url = `/api/FreelancerLineItem/GetLineItemById/${id}`;

  //   return AuthService.getInstance().CallBackendFunction(url);
  // }

  static LookingForTimeBasedLineItems(id) {
    const url = '/api/FreelancerLineItem/LookingForTimeBasedLineItems';

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetLineItemListByInvoiceId(id) {
    const url = `/api/FreelancerLineItem/GetLineItemsByInvoiceId/${id}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBFreelancerLineItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new FreelancerLineItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static async EditOrCreateFreelancerLineItem(editedItem) {
    let saveItem = { ...editedItem };
    const url = `api/FreelancerLineItem/PutFreelancerLineItem/${saveItem.FreelancerUserId}`;
    saveItem = FreelancerLineItem.CorrectingTypes(saveItem);
    const editedItemJSON = JSON.stringify(saveItem);

    return AuthService.getInstance().CallBackendFunctionPut(url, editedItemJSON);
  }

  static async RepeatLineItem(data) {
    const url = 'api/FreelancerLineItem/RepeatLineItem';
    data.PeriodMonth = parseInt(data.PeriodMonth);
    const dataJson = JSON.stringify(data);
    return AuthService.getInstance().CallBackendFunctionPut(url, dataJson);
  }

  static async RemoveFreelancerPayableAssignmentsFromInvoice(selectedIds) {
    const url = 'api/FreelancerLineItem/RemoveFreelancerLineItemsFromInvoice';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(selectedIds));
  }
}

export default FreelancerLineItemService;
